import DocumentList from 'components/DocumentList';
import Error from 'components/form/Error';
import { DefaultLoader, LoaderContainer } from 'components/Loader';
import { PageHeadContainer, PageTitle } from 'components/PageHead';
import { FC } from 'react';
import styled from 'styled-components';
import useSWR from 'swr';
import DocumentationFile from 'types/DocumentationFile';

const Container = styled.div`
  max-width: 40rem;
  align-self: center;
  margin-top: 2rem;
  color: var(--gray-600);
  p {
    margin-bottom: 1rem;
  }
`;

const Documents: FC = () => {
  const { data, error } = useSWR<DocumentationFile[]>(
    '/files/documentation-files/mentor',
  );
  return (
    <>
      <PageHeadContainer>
        <PageTitle>
          <h1>Supports pédagogiques</h1>
        </PageTitle>
      </PageHeadContainer>
      <Container>
        <p>Voici la liste des supports pédagogiques déstinés aux mentors.</p>
        <p>
          Vous y trouverez tous les documents à télécharger vous apportant des
          informations complémentaires concernant le rôle de mentor.
        </p>
        {data ? (
          <DocumentList
            documents={data}
            emptyText="Aucun document n'est disponible pour le moment."
            downloadUrl="/files/documentation-file/mentor"
          />
        ) : error ? (
          <Error style={{ textAlign: 'center' }}>
            Une erreur est survenue.
          </Error>
        ) : (
          <LoaderContainer>
            <DefaultLoader />
          </LoaderContainer>
        )}
      </Container>
    </>
  );
};

export default Documents;
